<template>
    <HeadlessMenu as="div" class="relative">
        <MenuButton class="flex w-full items-center gap-2.5 rounded-lg border border-white/15 bg-white px-2.5 py-2 text-left shadow-xl shadow-indigo-950/20 ring-1 ring-slate-900/5 transition hover:bg-slate-50">
            <span class="flex size-8 shrink-0 items-center justify-center rounded-full bg-indigo-100 text-xs font-bold text-indigo-700">
                {{ adminInitials }}
            </span>
            <span class="min-w-0 flex-1">
                <span class="block truncate text-sm font-semibold text-slate-900">{{ adminName }}</span>
            </span>
            <ChevronUpIcon class="size-4 shrink-0 text-slate-400" aria-hidden="true" />
        </MenuButton>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="translate-y-1 transform opacity-0 scale-95"
            enter-to-class="translate-y-0 transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="translate-y-0 transform opacity-100 scale-100"
            leave-to-class="translate-y-1 transform opacity-0 scale-95"
        >
            <MenuItems class="absolute bottom-full left-0 z-20 mb-1 w-full origin-bottom rounded-lg border border-slate-200 bg-white py-2 shadow-xl ring-1 ring-slate-900/5 focus:outline-none">
                <MenuItem v-for="item in userNavigation" :key="item.name" v-slot="{ active }">
                    <RouterLink
                        :to="item.to"
                        :class="[active ? 'bg-slate-50 outline-none' : '', 'mx-2 block rounded-lg px-3 py-2 text-sm/6 text-slate-900 transition']"
                    >
                        {{ item.name }}
                    </RouterLink>
                </MenuItem>

                <MenuItem key="logout" v-slot="{ active }">
                    <a
                        href="#"
                        @click.prevent="logout"
                        :class="[active ? 'bg-slate-50 outline-none' : '', 'mx-2 block cursor-pointer rounded-lg px-3 py-2 text-sm/6 text-slate-900 transition']"
                    >
                        Logout
                    </a>
                </MenuItem>
            </MenuItems>
        </transition>
    </HeadlessMenu>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import VueCookies from 'vue-cookies'
import { Menu as HeadlessMenu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ChevronUpIcon } from '@heroicons/vue/24/outline'
import { useAdminAuthStore } from '@/composables/useAdminAuthStore'

const route = useRoute()
const router = useRouter()
const adminAuthStore = useAdminAuthStore()

const adminName = computed(() => adminAuthStore.admin?.name || adminAuthStore.admin?.email || 'Account')
const adminInitials = computed(() => {
    const value = adminAuthStore.admin?.name || adminAuthStore.admin?.email || 'A'
    const parts = String(value).trim().split(/\s+/).filter(Boolean)

    if (parts.length >= 2) {
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
    }

    return String(value).slice(0, 2).toUpperCase()
})

const userNavigation = computed(() => [
    { name: 'Profile', to: { name: 'profile', params: { tenantId: route.params.tenantId } } },
])

const logout = async () => {
    adminAuthStore.clearAdmin()
    VueCookies.remove('admin_token')

    await router.push({ name: 'login' })
}
</script>
